import { defineSagaForService, DownloadQueriesSagasFactory, QueriesSagasFactory } from '@repo/core'
import { all, takeLatest } from 'redux-saga/effects'
import { watchInitContactDataForm } from './contactData'
import {
  convenienceTestQuestionnaireServiceConfig,
  watchClearConvenienceTest,
  watchInitializeConvenienceTestAnswers,
  watchUpdateRelatedFieldsAnswers,
} from './convenienceTest'
import {
  convenienceTestsDraftMutationsServiceConfig,
  convenienceTestsDraftPdfDownloadConfig,
  convenienceTestsServiceConfig,
} from './convenienceTests'
import {
  devicesMutationsServiceConfig,
  devicesServiceConfig,
  watchCloseDialogOnSuccess,
  watchDeviceActions,
} from './devices'
import { mailingAddressRelatedProductsServiceConfig } from './mailingAddressRelatedProducts'
import { watchUsersNotifications } from './notifications'
import { otpMutationsServiceConfig } from './otp'
import {
  changePasswordMutationsServiceConfig,
  checkUserMutationsServiceConfig,
  recoverPasswordMutationsServiceConfig,
} from './security'
import { taxAddressRelatedProductsServiceConfig } from './taxAddressRelatedProducts'
import { preferencesMutationsServiceConfig, userInfoServiceConfig } from './user'

const serviceConfig = defineSagaForService({
  ...userInfoServiceConfig,
  ...taxAddressRelatedProductsServiceConfig,
  ...convenienceTestsServiceConfig,
  ...convenienceTestsDraftMutationsServiceConfig,
  ...devicesServiceConfig,
  ...devicesMutationsServiceConfig,
  ...otpMutationsServiceConfig,
  ...convenienceTestQuestionnaireServiceConfig,
  ...preferencesMutationsServiceConfig,
  ...mailingAddressRelatedProductsServiceConfig,
  ...changePasswordMutationsServiceConfig,
  ...checkUserMutationsServiceConfig,
  ...recoverPasswordMutationsServiceConfig,
})

const fileDownloadConfig = {
  ...convenienceTestsDraftPdfDownloadConfig,
}

const serviceSagas = Object.keys(serviceConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, QueriesSagasFactory(serviceConfig, actionTypeRequest)),
)

const fileDownloadSagas = Object.keys(fileDownloadConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, DownloadQueriesSagasFactory(fileDownloadConfig, actionTypeRequest)),
)

export function* rootUsersSaga() {
  yield all([
    ...serviceSagas,
    ...fileDownloadSagas,
    watchUsersNotifications(),
    watchDeviceActions(),
    watchCloseDialogOnSuccess(),
    watchInitializeConvenienceTestAnswers(),
    watchUpdateRelatedFieldsAnswers(),
    watchInitContactDataForm(),
    watchClearConvenienceTest(),
  ])
}
